import { connect } from 'react-redux'

import { receiveAccounts } from 'modules/accounts/actions'
import { showTransientNotification, receiveUserSettings } from '@driftt/traffic-control'

import AccountsHome from 'pages/AccountsHome'
import { hasGates } from 'utils/access'

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    users: state.org.users,
    settings: state.user.settings,
    currentUserId: state.user.id,
    bootstrapComplete: state.config.bootstrapComplete,
    hasDemoOrg: hasGates('has_demo_org'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onReceiveUserSettings: settings => {
      dispatch(receiveUserSettings(settings))
    },

    onReceiveAccounts: accounts => {
      dispatch(receiveAccounts(accounts))
    },

    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountsHome)
